import { TextField } from '@mui/material';
import PropTypes from 'prop-types';
import { useState } from 'react';
import { saveOutsourceCompany } from '../../../../api/transports';
import { useSelector } from '../../../../redux/store';
import { useSnackbar } from '../../../../reusable-components/snackbar';
import FacilitySelector from '../Shared/FacilitySelector';
import EditModal from './EditModal';

OutsourceCompanyModal.propTypes = {
  edit: PropTypes.bool,
  row: PropTypes.object,
  onAdded: PropTypes.func,
};

export default function OutsourceCompanyModal({ edit, row, onAdded }) {
  const [open, setOpen] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const [value, setValue] = useState({
    id: null,
    name: null,
    facilityId: null,
    deleteFlag: false,
  });
  const transportsState = useSelector((state) => state.transports);
  const facilities = transportsState?.data?.facilities ?? [];
  const facilityDataIsLoading = transportsState?.isLoading ?? false;

  const handleSave = async () => {
    try {
      const response = await saveOutsourceCompany(value);
      const result = response.data;
      if (result.success) {
        setOpen(false);
        enqueueSnackbar(result.message || 'Outsource Company updated successfully', { variant: 'success' });
        if (onAdded) onAdded();
      } else {
        enqueueSnackbar(result.message || 'Failed to update Outsource Company', { variant: 'error' });
      }
    } catch (error) {
      // Show backend error if present
      const errorMsg = 'Failed to update Outsource Company';
      enqueueSnackbar(errorMsg, { variant: 'error' });
    }
  };

  const handleClickOpen = () => {
    setValue({
      id: edit ? row.id : undefined,
      name: edit ? row.name : null,
      facilityId: edit ? row.facilityId : null,
      deleteFlag: edit ? row.deleteFlag : false,
    });
    setOpen(true);
  };

  const handleClose = () => {
    setValue({
      id: null,
      name: null,
      facilityId: null,
      deleteFlag: false,
    });
    setOpen(false);
  };

  const fields = [
    {
      label: 'Name',
      element: (
        <TextField
          fullWidth
          size="small"
          value={value.name || ''}
          onChange={(e) =>
            setValue({
              ...value,
              name: e.target.value,
            })
          }
          label=""
          sx={{
            mt: 1,
            '& legend': { display: 'none' },
            '& fieldset': { top: 0 },
            '& .MuiFormLabel-root ': { display: 'none' },
          }}
          autoComplete="off"
        />
      ),
    },
    {
      label: 'Facility',
      element: (
        <FacilitySelector
          facilities={facilities}
          value={value.facilityId}
          onChange={(val) =>
            setValue({
              ...value,
              facilityId: val,
            })
          }
          isLoading={facilityDataIsLoading}
          inputProps={{ 'aria-label': 'Facility Selector' }}
        />
      ),
    },
  ];

  return (
    <EditModal
      handleClickOpen={handleClickOpen}
      editEntity="Outsource Company"
      handleClose={handleClose}
      handleSave={handleSave}
      disableSave={!value.name || !value.facilityId}
      fields={fields}
      edit={edit}
      open={open}
    />
  );
}
